export default __webpack_public_path__ + "4a1588d47ca69344778f86b23f212ab0.png";